import { Injectable, inject } from '@angular/core';
import { JsonApiWrap } from '../../shared/models/JsonApiWrap';
import { AchInputRequest } from '../models/ach/AchInputRequest';
import { AchInputApiResponse } from '../models/ach/AchInputApiResponse';
import { Observable } from 'rxjs';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { AchVerifyRequest } from '../models/ach/AchVerifyRequest';
import { AchVerifyApiResponse } from '../models/ach/AchVerifyApiResponse';
import { AchAcknowledgeRequest } from '../models/ach/AchAcknowledgeRequest';
import { AchAcknowledgeApiResponse } from '../models/ach/AchAcknowledgeApiResponse';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { IntegrationService } from '../../shared/services/integration.service';

@Injectable({ providedIn: 'root', })
export class AchService {
  acknowledgementConsentEnabled: boolean = false;
  private headersService = inject(HeadersService);
  private baseService = inject(BaseRestService);
  private integrationService = inject(IntegrationService);

  mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';

  callAchInput(requestData: AchInputRequest): Observable<AchInputApiResponse> {
    const serviceUrl
      = this.integrationService.JfkEnv.BaseUrl
        + this.mmExperienceApiPath
        + '/v1/MoneyLinkInput';
    const requestBody: JsonApiWrap<AchInputRequest> = {
      data: {
        type: 'moneylink-input-request',
        id: '',
        attributes: requestData,
      },
    };
    const headers
      = this.headersService.createHeadersWithJsonApiContentSharedToken(
        '1',
        requestData.correlationId
      );

    return this.baseService.post<AchInputRequest, AchInputApiResponse>(
      serviceUrl,
      headers,
      requestBody,
      true
    );
  }

  callAchVerify(
    requestData: AchVerifyRequest,
    isPathEnabled: boolean = false,
  ): Observable<AchVerifyApiResponse> {
    const serviceUrl
      = this.integrationService.JfkEnv.BaseUrl
        + this.mmExperienceApiPath
        + '/v1/MoneyLinkVerify';
    const requestBody: JsonApiWrap<AchVerifyRequest> = {
      data: {
        type: 'moneylink-verify-request',
        id: '',
        attributes: requestData,
      },
    };
    const versionNumber = isPathEnabled ? '2' : '1';
    const headers
      = this.headersService.createHeadersWithJsonApiContentSharedToken(versionNumber);

    return this.baseService.post<AchVerifyRequest, AchVerifyApiResponse>(
      serviceUrl,
      headers,
      requestBody,
      true
    );
  }

  callAchAcknowledge(
    requestData: AchAcknowledgeRequest
  ): Observable<AchAcknowledgeApiResponse> {
    const serviceUrl
      = this.integrationService.JfkEnv.BaseUrl
        + this.mmExperienceApiPath
        + '/v1/MoneyLinkAcknowledge';
    const requestBody: JsonApiWrap<AchAcknowledgeRequest> = {
      data: {
        attributes: requestData,
        type: 'moneylink-acknowledge-request',
        id: '',
      },
    };
    const headers
      = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    headers['Acknowledgement-Consent'] = 'true';


    return this.baseService.post<
      AchAcknowledgeRequest,
      AchAcknowledgeApiResponse
    >(serviceUrl, headers, requestBody, true);
  }
}
